import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { actionCreators as chatTicketActionsCreators } from 'react/api/actions/chatTicketActions';
import { actionCreators as toastAlertsCreators } from 'react/api/actions/toastAlerts';
import { connect } from 'react-redux';
import { getResourceTo } from 'react/utils/chatUtils';
import BaseToast from './baseToast';

const TicketNotification = ({
  toastData,
  removeToast,
  submitAcceptCall,
  toggleReassignCallModal
}) => {
  function removeThisToast() {
    removeToast({ id: toastData.getIn(['data', 'ticketId']) });
  }

  function handleAcceptTicket() {
    submitAcceptCall(toastData.get('data'));
    removeThisToast();
  }

  function handleReassignTicket() {
    toggleReassignCallModal(toastData.get('data'));
  }

  const isReasigned = useMemo(() => toastData.getIn(['data', 'status']) === 'RE_ASSIGNED',
    [toastData]);

  const header = () => (
    <>
      <h4>{getResourceTo('Greenmile.Chat.NewTicketNotification.Title')}</h4>
      <span className="relative-data">{moment(toastData.getIn(['data', 'createdDate'])).fromNow()}</span>
    </>
  );

  const body = () => (
    <>
      <strong>{toastData.getIn(['data', 'ticketTitle'])}</strong>
      <p className="fromName">{toastData.getIn(['data', 'userName'])}</p>
      <p className="fromRoute">
        <b>{`${getResourceTo('stop.route')}: `}</b>
        {toastData.getIn(['data', 'routeKey'])}
      </p>
      <p className="fromStop">
        <b>{`${getResourceTo('stop')}: `}</b>
        {toastData.getIn(['data', 'stopDescription'])}
      </p>
    </>
  );

  const footer = () => (
    <>
      {isReasigned && (
        <input
          className="reasign-button"
          type="button"
          value="Reassign"
          onClick={handleReassignTicket}
        />
      )}
      <input
        type="button"
        value={getResourceTo('Greenmile.Chat.NewTicketNotification.AcceptButton')}
        onClick={handleAcceptTicket}
      />
    </>
  );

  return (
    <BaseToast
      toastId={toastData.getIn(['data', 'ticketId'])}
      className={String(toastData.getIn(['data', 'status'])).toLowerCase()}
      header={header()}
      body={body()}
      footer={footer()}
      data-testid={`ticket-toast-${toastData.getIn(['data', 'status'])}-${toastData.get('id')}`}
    />
  );
};

TicketNotification.propTypes = {
  toastData: PropTypes.object.isRequired,
  removeToast: PropTypes.func.isRequired,
  submitAcceptCall: PropTypes.func.isRequired,
  toggleReassignCallModal: PropTypes.func.isRequired
};

const mapDispatchToProps = {
  removeToast: toastAlertsCreators.removeToast,
  submitAcceptCall: chatTicketActionsCreators.submitAcceptCall,
  toggleReassignCallModal: chatTicketActionsCreators.toggleReassignCallModal
};

export default connect(null, mapDispatchToProps)(TicketNotification);
